export const CONFIG = {
  ASSETS_BASE_URL: 'https://assets.kronansapotek.se',
};
